/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatpresetinstagramstory3Inputs */

const en_formatpresetinstagramstory3 = /** @type {(inputs: Formatpresetinstagramstory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram Story`)
};

const de_formatpresetinstagramstory3 = /** @type {(inputs: Formatpresetinstagramstory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram Story`)
};

/**
* | output |
* | --- |
* | "Instagram Story" |
*
* @param {Formatpresetinstagramstory3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatpresetinstagramstory3 = /** @type {((inputs?: Formatpresetinstagramstory3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatpresetinstagramstory3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatpresetinstagramstory3(inputs)
	return de_formatpresetinstagramstory3(inputs)
});
export { formatpresetinstagramstory3 as "formatPresetInstagramStory" }